<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>助力活动>助力详情</div>
		<div class="title">
			<div class="left">
			</div>
			<div class="right">
				<el-select v-model="activeState" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" placeholder="请输入团长名称" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small">筛选</el-button>
				<el-button type="primary" size="small" style="margin-left: 20px;">导出数据</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="name1" align="center" label="产品名称"></el-table-column>
				<el-table-column label="助力时间" prop="name2" align="center" width="200"></el-table-column>
				<el-table-column prop="name3" align="center" label="结束时间"></el-table-column>
				<el-table-column prop="name4" align="center" label="助力人数"></el-table-column>
				<el-table-column align="center" prop="name5" label="参团人数"></el-table-column>
				<el-table-column align="center" label="状态">
					<template slot-scope="scope">
						<span>{{scope.row.name6==1?'助力中':'已结束'}}</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background style="margin-top: 30px;" layout="prev, pager, next" :page-size="10" :total="80">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeState: "全部活动",
				activeStateList: [],
				activeTime: "",
				dataList: [{
					name1: "Red",
					name2: "2020-08-17 20:00",
					name3: "2020-08-18 20:00",
					name4: 6,
					name5: 3,
					name6: 1
				}],
				deleteAd: false
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}
</style>